import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import styles from './viewTimelines.module.scss';
import Modal from '@cp/src/components/Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { IAttributes } from '../../interfaces';
import cx from 'classnames';
import CopyToClipboardIcon from '@cp/src/assets/icons/CopyToClipboardIcon';
import { copyToClipboard } from '@cp/src/utils/commonUtils';
import { Button } from '@navi/web-ui/lib/primitives';
import { useEffect } from 'react';
import { getAttributesByTenant } from '@cp/pages/Paramount/paramountActions';
import useGetTenant from '@cp/pages/Paramount/hooks/useGetTenant';

interface AttributesModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const AttributesModal = (props: AttributesModalProps) => {
  const { isOpen, setIsOpen } = props;

  const attributes = useSelector((state: RootState) => state.paramountSlice.attributes);
  const tenant = useGetTenant();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAttributesByTenant(tenant));
  }, []);

  // const attributes = [
  //   {
  //     tenantReferenceId: '9e9bde38-82d4-4405-b7a8-f0be885ed6f7',
  //     referenceId: '95bc8c76-ba68-4634-aaf1-8aa0e2d77d2b',
  //     attributeKey: 'bounceFlags',
  //     attributeDataType: 'DOUBLE',
  //     description: 'emi amount',
  //     isMandatory: true,
  //     source: 'COLLECTION_CASE_MANAGER',
  //     enabled: true,
  //     id: 3,
  //     createdAt: '2024-05-10T09:43:32',
  //     updatedAt: '2024-05-10T09:43:32',
  //     version: 0,
  //     createdBy: 'suraj',
  //     lastModifiedBy: 'suraj'
  //   },
  //   {
  //     tenantReferenceId: '9e9bde38-82d4-4405-b7a8-f0be885ed6f7',
  //     referenceId: '95bc8c76-ba68-4634-aaf1-8aa0e2d77d2b',
  //     attributeKey: 'bounceFlags',
  //     attributeDataType: 'DOUBLE',
  //     description: 'emi amount',
  //     isMandatory: true,
  //     source: 'COLLECTION_CASE_MANAGER',
  //     enabled: true,
  //     id: 3,
  //     createdAt: '2024-05-10T09:43:32',
  //     updatedAt: '2024-05-10T09:43:32',
  //     version: 0,
  //     createdBy: 'suraj',
  //     lastModifiedBy: 'suraj'
  //   }
  // ];

  const AttributeCard = (attribute: IAttributes) => {
    return (
      <div className="w-[100%] relative flex flex-row my-[20px] py-[20px] bg-greyscale-extra-light">
        {attribute?.isMandatory && (
          <Typography
            variant="p4"
            className={cx(styles.mandatory, 'flex justify-end absolute right-0 top-0 ')}
          >
            Mandatory
          </Typography>
        )}
        <div className="flex justify-between gap-[100px] px-[20px] w-[100%]">
          <div className="flex flex-col gap-[10px]">
            <div className="flex flex-row items-center gap-[8px]">
              <Typography variant="h3">Attribute : </Typography>
              <Typography variant="p2"> {attribute?.attributeKey}</Typography>
              <Button variant="text" onClick={() => copyToClipboard(attribute?.attributeKey)}>
                <CopyToClipboardIcon width={16} height={16} />
              </Button>
            </div>
            <div className="flex flex-row items-center gap-[8px]">
              <Typography variant="h3">Description : </Typography>
              <Typography variant="p2">{attribute?.description}</Typography>
            </div>
          </div>
          <div className="flex flex-col">
            <Typography variant="p4" className="pt-[8px]">
              {attribute?.attributeDataType}
            </Typography>
            <Typography variant="p5" className="flex justify-end">
              (type)
            </Typography>
          </div>
        </div>
      </div>
    );
  };
  return (
    <Modal
      visible={isOpen}
      headerClassName={'bg-[#f1f9f9] rounded'}
      onClose={() => setIsOpen(false)}
      header={'All Attributes'}
      iconButtonSize="small"
    >
      {attributes.length ? (
        <div className="w-[700px] h-[600px] overflow-auto">
          <div className="py-[20px]">
            {attributes?.map(attribute => (
              <AttributeCard {...attribute} key={attribute?.id} />
            ))}
          </div>
        </div>
      ) : (
        <div className="px-[20px]">
          <Typography variant={'p4'}>No Attributes Found</Typography>
        </div>
      )}
    </Modal>
  );
};
export default AttributesModal;
